import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL);
console.log('Supabase Key:', process.env.REACT_APP_SUPABASE_ANON_KEY);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}



export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface VittaCall {
  call_id: string;
  action_id: number;
  in_type_id: number;
  entry: string;
  stoploss: string;
  target: string;
  exit?: string;
  created_by?: string;
  created_on: string;
  name: string;
}

export interface VittaPlan {
  plan_id: string;
  plan_name: string;
  plan_details: string;
  price?: number;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  phone: string;
  plan_id?: string;
  created_at: string;
}